/** Shared local-native zone / renderer identification (#895). */

export function isLocalNativeRendererId(rendererId: string | null | undefined): boolean {
  if (!rendererId) return false;
  const id = rendererId.trim().toLowerCase();
  return id === 'local-native' || id.startsWith('local-native:');
}

export function isLocalNativeZone(zone: { id?: string; type?: string } | null | undefined): boolean {
  if (!zone) return false;
  if (zone.type === 'local-native') return true;
  return isLocalNativeRendererId(zone.id);
}

/** True when the exclusive engine reports audible or confirmed output. */
export function exclusiveEngineReportsPlaying(state: {
  is_playing?: boolean;
  playback_started?: boolean;
} | null | undefined): boolean {
  if (!state) return false;
  return state.is_playing === true || state.playback_started === true;
}
